import { render, staticRenderFns } from "./icon-loss.vue?vue&type=template&id=467be8ba&"
import script from "./icon-loss.vue?vue&type=script&lang=js&"
export * from "./icon-loss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports